import React, { useState } from 'react';
import { calculateVoiceQuote } from '../utils/voicePricing';

export default function JobScriptDownload({ job, options }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  let invalid = false;
  try { calculateVoiceQuote(job.text, job.status === 'fulfilled' ? undefined : options); } catch { invalid = true; }
  async function download() {
    setBusy(true);
    setError('');
    try {
      const { downloadVoiceScript } = await import('../utils/voiceScriptDocument');
      await downloadVoiceScript(job, options);
    } catch {
      setError('Wordファイルを作成できませんでした。もう一度お試しください。');
    } finally { setBusy(false); }
  }
  return <div className="job-script-download">
    <div className="voice-actions"><button type="button" disabled={busy || invalid} onClick={download}><svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3v12m-5-5 5 5 5-5M4 16v5h16v-5" /></svg><span>{busy ? 'Wordファイルを作成中…' : '台本をWordでダウンロード（.docx）'}</span></button></div>
    <p className="jobs-note">台本の末尾に別ページで文字数・単価・料金明細・収録条件を収録します。{job.status === 'fulfilled' ? '契約済み案件の料金は、募集時の標準条件による参考額です。' : '下の単価・収録オプションの選択を反映します。'}</p>
    {invalid && <p role="alert">単価・チップを正しく入力するとダウンロードできます。</p>}
    {error && <p role="alert">{error}</p>}
  </div>;
}
